document.addEventListener('DOMContentLoaded', () => {
  const personalCancelForm = document.querySelector('#personal-cancel-form');
  if (personalCancelForm) {
    const confirmCancelButton = document.querySelector(
      '#confirm-cancel-contract-basic-btn',
    );
    confirmCancelButton?.addEventListener('click', () => {
      const submitType = (personalCancelForm as HTMLElement).dataset.type;
      if (submitType === 'recurring') {
        (
          document.querySelector('#recurring-cancel-form-submit') as HTMLElement
        ).click();
      } else {
        (
          document.querySelector('#sbps-cancel-form-submit') as HTMLElement
        ).click();
      }
    });
  }
});
